import React from "react";
import { Link } from "react-router-dom";
import pipaanlogo from "../../assets/pipaanlogo.png";

// Plain page frame for the membership pages (logo + content), like the public artist page.
export default function FanMembershipShell({ children }) {
  return (
    <div className="min-h-screen w-full bg-white">
      <header className="border-b border-gray-100 px-4 md:px-10 py-4 flex items-center justify-between">
        <Link to="/home" aria-label="Nyawoo home">
          <img src={pipaanlogo} alt="Nyawoo" className="h-8 w-auto" />
        </Link>
      </header>
      <main className="px-4 md:px-10 py-8 md:py-12">{children}</main>
    </div>
  );
}
